/**
 * Created by ianva on 16/4/13.
 */

var domainPC = '//tmall.xcds.com.cn';
var domainH5 = '//s.xcds.com.cn';

module.exports = {
    buyUrl : {
        pc: domainPC + '/order/userorder/',
        h5: domainH5 + '/order/userorder/'
    },
    orderUrl : {
        pc : domainPC + '/order/confirm/order',
        h5 : domainH5 + '/order/confirm/order'
    },
    orderDetaillUrl: {
        pc : domainPC + '/order/userorder/packagedetail',
        h5 : domainH5 + '/order/userorder/packagedetail'
    }
}


/** WEBPACK FOOTER **
 ** ./script/conf/order-target.js
 **/